import { JSX } from 'react';
import { VerticalVideoCard } from '@ahc-digital/component-library';
import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { C42VerticalVideoCardProps } from './C42VerticalVideoCard.types';

const Default = (props?: C42VerticalVideoCardProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing ?? false;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );
  const videoId = props?.fields?.YouTubeID?.value?.trim();

  if (isEditing) {
    return (
      <div data-component={marketingRenderingName}>
        <b>YouTube Video ID:</b> <Text field={props?.fields?.YouTubeID} />
      </div>
    );
  }

  if (!videoId) {
    return <></>;
  }

  return (
    <VerticalVideoCard
      videoId={videoId}
      hasShadow={props?.hasShadow}
      isActive={props?.isActive}
      onReady={props?.onReady}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C42VerticalVideoCardProps>(Default);
